module.exports = __webpack_public_path__ + "img/img8.62cbea57.png";